import React from 'react';
import styled from 'styled-components';
import { CrudStyles } from '../shared/Crud';
import CostCenterEligibleEmployeesList from './CostCenterEligibleEmployeesList';

const { Button } = CrudStyles;

const Overlay = styled.div`
    position: fixed;
    inset: 0;
    box-sizing: border-box;
    padding: 16px;
    overflow-y: auto;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
`;

const ModalBox = styled.div`
    box-sizing: border-box;
    background: #fff;
    border-radius: 12px;
    width: 100%;
    max-width: min(1100px, calc(100vw - 32px));
    max-height: min(92vh, 92dvh);
    overflow-y: auto;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    padding: 16px;
`;

const Header = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid ${({ theme }) => theme?.colors?.gray?.[200] || '#e5e7eb'};

    h2 {
        margin: 0;
        font-size: 18px;
        color: ${({ theme }) => theme?.colors?.gray?.[900] || '#222'};
    }
`;

const Subtitle = styled.p`
    margin: 6px 0 0;
    font-size: 13px;
    line-height: 1.45;
    color: ${({ theme }) => theme?.colors?.gray?.[600] || '#64748b'};
    max-width: 42rem;
`;

export default function CostCenterAssociateEmployeesModal({
    open,
    customerId,
    costCenterId,
    idPrefix = 'cc-associate-modal',
    onClose,
    onAssociated,
}) {
    if (!open) return null;

    return (
        <Overlay role="dialog" aria-modal="true" onClick={(e) => e.target === e.currentTarget && onClose?.()}>
            <ModalBox onClick={(e) => e.stopPropagation()}>
                <Header>
                    <div>
                        <h2>Associar colaborador</h2>
                        <Subtitle>
                            Filtre por nome ou e-mail e clique em <strong>Adicionar</strong> para vincular ao centro de
                            custo.
                        </Subtitle>
                    </div>
                    <Button type="button" variant="outline" onClick={onClose}>
                        Fechar
                    </Button>
                </Header>
                <CostCenterEligibleEmployeesList
                    customerId={customerId}
                    costCenterId={costCenterId}
                    idPrefix={idPrefix}
                    onAssociated={onAssociated}
                    embedInModal
                />
            </ModalBox>
        </Overlay>
    );
}

